import { combineReducers } from 'redux'
import update from 'immutability-helper'
import Login from './../views/containers/Login/state'
import Dropdowns from '@BaseComponents/Common/BaseAutocomplete/state'

export const defaultState = {
    error: false,
    message: '',
}

export const loaderState = {
    loading: false,
}

export function loaderReducer(state = loaderState, action) {
    switch (action.type) {
    case 'SHOW_BASE_LOADER':
        return update(state, {
            loading: { $set: true }
        })
    case 'HIDE_BASE_LOADER':
        return update(state, {
            loading: { $set: false }
        })
    default: return state;
    }
}

export function xhrReducer(state = defaultState, action) {
    switch (action.type) {
    case 'SHOW_XHR_ERROR':
        return update(state, {
            error: { $set: true },
                title: { $set: action.payload.title },
            message: { $set: action.payload.message },
        });
    case 'HIDE_XHR_ERROR':
        return update(state, {
            error: { $set: false },
        })
    default: return state;
    }
};

const createReducer = (asyncReducers) => {
    return combineReducers({
        loader: loaderReducer,
        auth: Login.reducer,
        dropdown: Dropdowns.reducer,
        xhrError: xhrReducer,
        ...asyncReducers
    })
}

export default createReducer
